import { memo, useMemo } from "react";

import { useCollectionFilters } from "@react/sections/Collection/CollectionFiltersContext";
import { CollectionGridPlaceholder } from "@react/sections/Collection/CollectionGrid/CollectionGridPlaceholder.view";
import {
  type CollectionContentCard as CollectionContentCardType,
  type OPProductConnection,
} from "@tablescape/state";

import { CollectionGridView } from "./CollectionGrid.view";

type Props = {
  contentCards: Array<{
    contentCard: CollectionContentCardType;
    id: string;
    position: string;
  }> | null;
  isLoadingMore: boolean;
  nextLabel: string;
  prevLabel: string;
  productResults: Array<OPProductConnection>;
};

const CollectionGridBase = ({
  contentCards,
  isLoadingMore,
  nextLabel,
  prevLabel,
  productResults,
}: Props) => {
  const { appliedFilters, sortValue } = useCollectionFilters();

  const showContentCards = useMemo(
    () =>
      !!contentCards &&
      appliedFilters.length === 0 &&
      sortValue.sortKey === "COLLECTION_DEFAULT",
    [contentCards, appliedFilters, sortValue]
  );

  return !productResults.length ? (
    <CollectionGridPlaceholder />
  ) : (
    <CollectionGridView
      contentCards={contentCards}
      isLoadingMore={isLoadingMore}
      nextLabel={nextLabel}
      prevLabel={prevLabel}
      productResults={productResults}
      showContentCards={showContentCards}
    />
  );
};

export const CollectionGrid = memo(CollectionGridBase);
